enum CritEnum {
    Ourson = "992",
    Flocon = "993",
    _1ere_etoile = "994",
    _2eme_etoile = "995",
    _3eme_etoile = "996",
    Economique = "997",
    Débutant = "998",
    Confirmé = "999",
    Premium = "1000",
    Chaussures = "1001",
    Battons = "1002",
    Snowboard = "1014",
    Ski = "1015",
    Piou_Piou = "1016",
    Matinée = "1017",
    Après_Midi = "1018",
    Journée = "1019",
    Collectif = "1020",
    Panier_Gastronomique = "1021",
    Panier_Savoyard = "1022",
    Panier_Gourmand = "1023",
    Panier_Hallal = "1024",
    Panier_Enfant = "1025",
    Panier_Végétarien = "1026",
    Panier_Repas = "1027",

    Champion = "1030",
    Espoir = "1031",
    Mini_Kid = "1032",
    Bronze = "1038",
    first_class = "1039",
    second_class = "1040",
    level_0 = "1058",
    level_1 = "1059",
    level_2 = "1060",
    level_3 = "1061",
    level_4 = "1062",
    level_5 = "1063",
    NL_Ski = "1064",
    NL_Snowboard = "1065",

    SANS = '1013',
    SMILEPASS = "700",

    TNE_TRAIN_OUTBOUND = "1079",
    TNE_TRAIN_INBOUND = "1080",
    TNE_TRAIN_CLASS_STANDARD = "1086",
    TNE_TRAIN_CLASS_STANDARD_PLUS = "1087",
    TNE_TRAIN_CLASS_PREMIERE = "1088",
    TNE_TRAIN_TYPE_BED = "1089",
    TNE_TRAIN_TYPE_SEAT = "1090",
    TNE_TRAIN_TYPE_COMPARTMENT = "1091",

    TNE_ORIGIN_PARIS_OUTBOUND = "1092",
    TNE_ORIGIN_AMSTERDAM_OUTBOUND = "1096",
    TNE_ORIGIN_ROTTERDAM_OUTBOUND = "1097",
    TNE_ORIGIN_ANVERS_OUTBOUND = "1098",
    TNE_ORIGIN_BRUXELLES_OUTBOUND = "1099",
    TNE_ORIGIN_PARIS_INBOUND = "1100",
    TNE_ORIGIN_AMSTERDAM_INBOUND = "1104",
    TNE_ORIGIN_ROTTERDAM_INBOUND = "1105",
    TNE_ORIGIN_ANVERS_INBOUND = "1106",
    TNE_ORIGIN_BRUXELLES_INBOUND = "1107",
}

export default CritEnum